var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _path19, _path20, _path21, _path22, _g2, _g3, _g4, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g5, _path58, _path59, _g6, _g7, _g8, _g9, _g10, _g11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 684.88,
    height: 652.861,
    viewBox: "0 0 684.88 652.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hero_background-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 625.002,
    height: 652.861,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hero_background-clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 625.002,
    height: 652.862,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hero_background-clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 61.069,
    height: 52.969,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hero_background-clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 16.398,
    height: 13.551,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hero_background-clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 35.966,
    height: 41.711,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hero_background-clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 17.435,
    height: 38.664,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hero_background-clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 23.078,
    height: 37.892,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hero_background-clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_194",
    "data-name": "Trac\\xE9 194",
    d: "M445.982,329.076l-25.337,25.337a13.209,13.209,0,0,0,0,18.68l25.337,25.337a13.209,13.209,0,0,0,18.68,0l16.484-16.484A20.277,20.277,0,0,1,478,381.42a16.212,16.212,0,0,1-8.222-4.977,34.887,34.887,0,0,1-2.584-3.537c-.565-.814-1.07-1.669-1.649-2.581-.575.895-1.125,1.7-1.625,2.541a19.79,19.79,0,0,1-3.737,4.729,17.187,17.187,0,0,1-9.256,4.271,18.185,18.185,0,0,1-7.965-.638,17.822,17.822,0,0,1-5.941-3.167,18.149,18.149,0,0,1-5.171-6.517,18.291,18.291,0,0,1,19.811-25.79,16.747,16.747,0,0,1,6.233,2.4,17.157,17.157,0,0,1,4.688,4.4,13.018,13.018,0,0,1,.741,1.136.481.481,0,0,1,.017.412c-1.319,2.1-2.653,4.2-4.034,6.371-.353-.549-.674-1.042-.988-1.539a16.279,16.279,0,0,0-3.107-4.03,10.1,10.1,0,0,0-5.226-2.311,11.241,11.241,0,0,0-9.252,19.342,11.015,11.015,0,0,0,14.145.907,11.9,11.9,0,0,0,2.762-3.212c2.02-3.208,4.07-6.4,6.1-9.6,1.286-2.026,2.572-4.051,3.84-6.089a17.834,17.834,0,0,1,5.636-5.809,16.909,16.909,0,0,1,6.532-2.447c.464-.071.924-.1,1.386-.143l-16.475-16.475a13.209,13.209,0,0,0-18.68,0",
    transform: "translate(-416.776 -325.207)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.069,
    y1: 5.542,
    x2: -1.066,
    y2: 5.542,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffab31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#ffa029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471,
    stopColor: "#ff8112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#ff6e05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hero_background-clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_195",
    "data-name": "Trac\\xE9 195",
    d: "M600.361,413.991a9.763,9.763,0,0,0-7.345,4.713c-1.3,2.034-2.579,4.076-3.887,6.1a.492.492,0,0,0,0,.636c1.312,2.043,2.6,4.1,3.916,6.141a10.117,10.117,0,0,0,8.887,4.812,11.179,11.179,0,0,0,9.241-4.925,10.575,10.575,0,0,0,1.558-3.34,13.262,13.262,0,0,0-.182-6.729,9.482,9.482,0,0,0-.861-1.821c-2.293-3.724-5.534-5.688-9.677-5.688a14.238,14.238,0,0,0-1.646.1",
    transform: "translate(-589.011 -413.893)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -5.348,
    y1: 16.047,
    x2: -5.339,
    y2: 16.047,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "hero_background-clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 74.23,
    height: 76.568,
    fill: "#defdff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hero_background-clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65-2",
    "data-name": "Rectangle 65",
    width: 23.353,
    height: 21.813,
    fill: "#defdff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "illu",
    transform: "translate(36.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_67",
    "data-name": "Groupe 67",
    clipPath: "url(#hero_background-clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_60",
    "data-name": "Groupe 60",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_59",
    "data-name": "Groupe 59",
    clipPath: "url(#hero_background-clip-path-2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_125",
    "data-name": "Trac\\xE9 125",
    d: "M331.31,102.839C206.642,136.312,143.989,232.048,87.988,313.707c-64.1,93.469-98.658,143.861-85.05,205.228,16.6,74.852,93.416,114.447,136.818,136.819,104.689,53.961,310.7,104.717,417.852-1.849,153.017-152.177,18.316-529.728-134.368-560.25-24.777-4.954-58.779.282-91.931,9.184",
    transform: "translate(0 -63.5)",
    fill: "#defdff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_126",
    "data-name": "Trac\\xE9 126",
    d: "M748.5,512.658,983.18,558.132a40.982,40.982,0,0,0,48.029-32.438l83.6-431.436a40.982,40.982,0,0,0-32.438-48.029L847.685.754a40.982,40.982,0,0,0-48.029,32.438l-83.6,431.436A40.981,40.981,0,0,0,748.5,512.658",
    transform: "translate(-495.11 0.002)",
    fill: "#2d292d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_127",
    "data-name": "Trac\\xE9 127",
    d: "M1156.611,149.178l-42.464,219.169-9.979,51.476-20.45,105.492a35.83,35.83,0,0,1-29.756,28.593,30.2,30.2,0,0,1-3.244.344,35.363,35.363,0,0,1-8.963-.59l-54.049-10.471-42.5-8.242-1.827-.352-1.311-.246-1.188-.229-18.041-3.5-36.507-7.079-49.108-9.512a35.808,35.808,0,0,1-28.348-41.972l30.863-159.328,42.021-216.8a35.815,35.815,0,0,1,41.972-28.356l19.835,3.842,184.7,35.787a35.81,35.81,0,0,1,28.348,41.972",
    transform: "translate(-559.416 -46.317)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_128",
    "data-name": "Trac\\xE9 128",
    d: "M1247.922,81.534c.63.626,1.267,1.243,1.914,1.845,13.814,12.925,30.675,22.463,47.111,31.605,16.323,9.088,33,17.724,48.284,28.531,14.557,10.3,27.695,22.737,36.394,38.469,10.679,19.3,13.312,41.679,13.677,63.4.66,39.153-5.857,81.024,12.636,117.4a76.125,76.125,0,0,0,10.563,15.681L1460.968,159.3a35.808,35.808,0,0,0-28.347-41.97Z",
    transform: "translate(-863.772 -56.435)",
    fill: "#0b6868"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_129",
    "data-name": "Trac\\xE9 129",
    d: "M1138.389,1520.458c-.5,2.05-1.959,24.857-21.493,32.641-1.954.778-10.864,3.832-24.921,1.418-61.08-10.488-207.2-39.793-207.564-39.137-.449.81,4.257,7.019,4.257,7.019s193.647,39.99,198.135,41.633,37.84,11.358,45.839-6.117,5.748-37.458,5.748-37.458",
    transform: "translate(-612.14 -1048.891)",
    fill: "#3b2a3b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_130",
    "data-name": "Trac\\xE9 130",
    d: "M460.813,1084.311s-7.365,2.507-18.877,6.383c-39.08,13.15-126,42.046-135.109,42.046-11.8,0-31.674-21.728-31.674-21.728L252.8,1038.98s61.349-25.119,104.755-43.242c20.523-8.562,37.04-15.566,41.169-17.606,3.113-1.54,5.956-2.917,8.48-4.121,3.482-1.663,6.35-2.991,8.463-3.958,1.237-.557,2.212-1,2.909-1.311.819-.36,1.253-.549,1.253-.549l.139.4.623,1.745,15.558,44.1,11.6,32.862,8.865,25.111a.027.027,0,0,0,.008.016l1.409,4,2.6,7.365Z",
    transform: "translate(-174.982 -670.152)",
    fill: "#fc932b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_131",
    "data-name": "Trac\\xE9 131",
    d: "M1394.79,1178.4l-3.023,15.583-.631,3.253-16.8,86.657a35.828,35.828,0,0,1-29.756,28.593,30.215,30.215,0,0,1-3.245.344,35.373,35.373,0,0,1-8.963-.59l-54.049-10.471-42.5-8.242-1.827-.352-1.311-.246-1.188-.229-3.416-47.879,117.355-81.962s25.6,5.391,49.354,15.542",
    transform: "translate(-850.039 -804.891)",
    fill: "#00aeb3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_132",
    "data-name": "Trac\\xE9 132",
    d: "M1694.044,1251.073l-.631,3.253-1.311-.271q-12.965-2.7-25.939-5.415c-2.056-.434-1.7-3.7.369-3.261l15.165,3.17c4.113.861,8.234,1.68,12.347,2.523",
    transform: "translate(-1152.316 -861.984)",
    fill: "#078989"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_133",
    "data-name": "Trac\\xE9 133",
    d: "M1442.518,1431.1c-5.4-6.718-12.527-11.748-18.393-18.016-3.654-3.916-6.292-8.521-9.5-12.789a105.368,105.368,0,0,0-12.552-13.92,1.646,1.646,0,0,0-2.507.713,74.084,74.084,0,0,1-8.717,17.967,10.615,10.615,0,0,1-2.835,3.384c-1.253.795-2.2,2.368-1.5,3.843a2.119,2.119,0,0,0,3.326.713,251.113,251.113,0,0,0,22.342,22.629,138.628,138.628,0,0,0,12.773,10.52c4.228,2.958,9.176,5.571,14.469,5.489a12.375,12.375,0,0,0,7.071-2.089c2.294-1.7,2.777-4.375,2.081-7.029a31.154,31.154,0,0,0-6.063-11.413",
    transform: "translate(-959.542 -959.37)",
    fill: "#078989"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_134",
    "data-name": "Trac\\xE9 134",
    d: "M1131.045,885.516a80.61,80.61,0,0,1-4.629,7.07,113.345,113.345,0,0,1-10.987,12.79c-8,8.127-16.918,15.28-25.767,22.457-18.778,15.223-37.638,30.412-57.678,43.963a349.854,349.854,0,0,1-30.846,18.745c-2.662,1.426-5.334,2.835-8.054,4.146-2.663,1.278-5.563,2.286-8.553,1.753-2.867-.516-5.415-2.04-7.955-3.392q-3.92-2.1-7.8-4.293a387.907,387.907,0,0,1-58.67-40.645,262.524,262.524,0,0,1-25.21-23.456c-6.235-6.816-11.79-14.4-15.452-22.9a1.563,1.563,0,0,1-.82-1.99c-.352-.9-.688-1.811-.991-2.736-.664-1.991,2.351-3.286,3.015-1.278.115.336.23.664.344.991q4.5-5.481,9.266-10.733a268.79,268.79,0,0,1,25.98-24.948c9.75-8.168,20.089-15.583,30.33-23.12q30.318-22.318,59.046-46.683,14.342-12.179,28.257-24.849,6.87-6.243,13.625-12.617c3.31-3.114,8.52-9.332,13.658-6.21a8.92,8.92,0,0,1,2.662,2.892c.852,1.278,1.7,2.565,2.548,3.842q2.691,4.068,5.366,8.136,5.345,8.135,10.651,16.312,10.593,16.344,20.974,32.829t20.548,33.1q5.014,8.2,9.979,16.427,2.507,4.166,5.014,8.349c1.491,2.491,3.384,5.039,4.088,7.89.729,2.982-.467,5.629-1.942,8.16",
    transform: "translate(-600.484 -516.86)",
    fill: "#fc932b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_135",
    "data-name": "Trac\\xE9 135",
    d: "M741.014,1077.681a.829.829,0,0,1-.123.057c-.164.082-.319.155-.483.229-.8.377-1.614.729-2.433,1.065a61.111,61.111,0,0,1-78.791-30.805q-1.254-2.692-2.212-5.432a61.169,61.169,0,0,1,27.577-73.548q2.126-1.2,4.375-2.245,2.028-.946,4.088-1.712c1.049-.41,2.106-.779,3.163-1.106.377-.131.762-.245,1.139-.352a61.178,61.178,0,0,1,72.835,32.911c.377.811.729,1.622,1.065,2.441a61.162,61.162,0,0,1-30.2,78.5",
    transform: "translate(-452.324 -665.39)",
    fill: "#fc932b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_136",
    "data-name": "Trac\\xE9 136",
    d: "M666.866,1002.944a87.163,87.163,0,0,1-29.6,11.675q-3.429.676-6.907,1.057a85.03,85.03,0,0,1-21.007-.221c-6.4-.877-12.928-2.646-18.352-6.178a162.981,162.981,0,0,1-17.164,39.515q-1.5,2.507-3.1,4.965A162.8,162.8,0,0,1,536,1092.173c-1.647,1.319-3.654-1.27-2.007-2.589q2.3-1.843,4.539-3.777a1.367,1.367,0,0,1-.811-1.229,63.018,63.018,0,0,1-.09-7.357c.459-10.036,3.236-19.786,5.842-29.429,1.311-4.818,2.6-9.643,3.564-14.534.917-4.654,1.548-9.365,2.089-14.067.844-7.406,1.458-14.854,2.638-22.219,20.523-8.562,37.04-15.567,41.169-17.607,3.113-1.54,5.956-2.917,8.48-4.121q2.126-1.2,4.375-2.245,2.028-.947,4.088-1.712c1.237-.557,2.212-1,2.909-1.311l.254.2c.59.459,1.172.926,1.761,1.393,4.973,3.941,10,7.816,15.206,11.445,10.954,7.627,22.891,14.157,36.041,17,1.237.27,2.171,2.081.819,2.925",
    transform: "translate(-369.188 -671.386)",
    fill: "#d86c12"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_137",
    "data-name": "Trac\\xE9 137",
    d: "M807.492,636.727c-8.693-3.1-82.763-4.5-100.592-37.256s-16.765-75.133,15.523-102.455,67.061-68.3,104.317-73.891,76.375-2.484,85.068,50.3S807.492,636.727,807.492,636.727",
    transform: "translate(-481.297 -291.494)",
    fill: "#fc932b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_138",
    "data-name": "Trac\\xE9 138",
    d: "M841,634.066c-9.935,1.242-49.362,1.245-70.166-19.559-17.386-17.386-13.55-53.045,8.072-71.718,109.285-94.382,118.6-65.82,118.6-65.82l4.347,81.343Z",
    transform: "translate(-525.98 -327.331)",
    fill: "#d86c12"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_139",
    "data-name": "Trac\\xE9 139",
    d: "M275.8,1226.805a61.162,61.162,0,1,1,29.741-81.223,61.163,61.163,0,0,1-29.741,81.223",
    transform: "translate(-130.735 -768.408)",
    fill: "#fc932b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_140",
    "data-name": "Trac\\xE9 140",
    d: "M904.659,424.821q-7.03,6.538-14.051,13.092c-4.187,3.892-8.373,7.849-13.322,10.766a58.839,58.839,0,0,1-14.42,5.792,94.631,94.631,0,0,1-15.845,3.023,70.206,70.206,0,0,1-16.172-.221,104.492,104.492,0,0,1-16.026-3.662c-8.881-2.663-18.835-6.817-21.211-16.812a12,12,0,0,1,3.179-11.5,10.747,10.747,0,0,1,7.988-3.171,17.525,17.525,0,0,1,.369-7.456,17.337,17.337,0,0,1,12.584-12.076c6.021-1.556,11.7.631,16.992,3.343.942-3.818,4.432-6.661,8.324-7.546,4.907-1.115,10.2.5,14.788,2.163a99.432,99.432,0,0,1,13.854,6.53c9.34,5.12,18.59,10.413,27.873,15.64a8.113,8.113,0,0,1,4.277-.827c1.54.107,1.786,2.023.819,2.924",
    transform: "translate(-549.066 -275.498)",
    fill: "#3d3033"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_141",
    "data-name": "Trac\\xE9 141",
    d: "M932.2,505.518c-1.17,37.086-35.057,66.111-75.688,64.828s-67.4-36.51-66.227-73.6,29.833-61.986,70.464-60.7,72.62,32.385,71.45,69.471",
    transform: "translate(-546.986 -301.784)",
    fill: "#3d3033"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_142",
    "data-name": "Trac\\xE9 142",
    d: "M1019.821,792.041l-39.433,50.3-30.912-18.1-29.011-16.984,51.271-35.983,4.055-2.851Z",
    transform: "translate(-637.117 -531.876)",
    fill: "#ffb48a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_46",
    "data-name": "Groupe 46",
    transform: "translate(283.348 239.395)",
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_45",
    "data-name": "Groupe 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_44",
    "data-name": "Groupe 44",
    clipPath: "url(#hero_background-clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_143",
    "data-name": "Trac\\xE9 143",
    d: "M972.319,805.286c-8.881,14.706-14.239,22.375-22.842,25.365l-29.011-16.984,51.271-35.983,9.692.877s1.753,8.717-9.11,26.725",
    transform: "translate(-920.466 -777.683)",
    fill: "#f15f5d"
  }))))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_144",
    "data-name": "Trac\\xE9 144",
    d: "M852.511,656.568c0,9.037,4.7,14.773.241,21.934-8.242,13.289-30.235,24.848-47.022,24.848a46.8,46.8,0,0,1-46.487-41.472c-.123-1.082-.213-2.171-.254-3.277-.033-.672-.049-1.352-.049-2.032a48.138,48.138,0,0,1,.508-6.923,46.788,46.788,0,0,1,93.063,6.923",
    transform: "translate(-525.314 -422.063)",
    fill: "#ffb48a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_145",
    "data-name": "Trac\\xE9 145",
    d: "M951.427,536.081a58.678,58.678,0,0,1-1.8,14.444,57.215,57.215,0,0,1-1.893,5.989c-.082.229-.164.45-.254.672-.532,1.368-1.114,2.7-1.745,4.023a58.205,58.205,0,0,1-3.982,7c-.688,1.049-1.417,2.064-2.18,3.064a23.923,23.923,0,0,1-13.379-6.735,8.061,8.061,0,0,1-4.539-2.253,8.958,8.958,0,0,1-2.278-6.071,51.282,51.282,0,0,1,.442-7.931,71.3,71.3,0,0,1,3.687-15.649c.467-1.294.983-2.572,1.516-3.834a10.607,10.607,0,0,0,1.016-3.244,4.849,4.849,0,0,0-1.376-3.564c-2.114-2.45-5.2-3.892-7.562-6.088a11,11,0,0,1-3.859-9.446c.418-3.7,2.376-7.046,4.064-10.3,1.376-2.663,2.908-5.579,3.2-8.627-4.129.614-8.267,1.131-12.429,1.524a234.394,234.394,0,0,1-48.42-.426c1.418-1.008,2.884-1.958,4.392-2.835a58.249,58.249,0,0,1,55.8-1.467q2.016,1.045,3.949,2.237a58.117,58.117,0,0,1,27.635,49.518",
    transform: "translate(-595.023 -330.8)",
    fill: "#3d3033"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_146",
    "data-name": "Trac\\xE9 146",
    d: "M884.417,592.879a58.529,58.529,0,0,1-16.705,14.878,56.6,56.6,0,0,1-7.669,3.8,58.124,58.124,0,0,1-79.848-48.781q-.234-2.519-.23-5.088a56.7,56.7,0,0,1,.475-7.406,58.039,58.039,0,0,1,19.86-36.77q2.015-1.732,4.195-3.277a234.41,234.41,0,0,0,48.42.426c4.162-.393,8.3-.909,12.428-1.524-.287,3.048-1.819,5.964-3.195,8.627-1.688,3.253-3.646,6.6-4.064,10.3a11,11,0,0,0,3.859,9.446c2.359,2.2,5.448,3.638,7.562,6.088a4.848,4.848,0,0,1,1.376,3.564,10.608,10.608,0,0,1-1.016,3.245c-.533,1.261-1.049,2.54-1.515,3.834a71.547,71.547,0,0,0-2.671,9.471q-.652,3.072-1.016,6.177a51.277,51.277,0,0,0-.442,7.931,8.958,8.958,0,0,0,2.278,6.071,7.73,7.73,0,0,0,3.695,2.073c.278.074.557.131.844.18a23.926,23.926,0,0,0,13.379,6.735",
    transform: "translate(-539.867 -352.409)",
    fill: "#ffb48a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_147",
    "data-name": "Trac\\xE9 147",
    d: "M1083.606,743.537a17.561,17.561,0,1,1-17.566-17.565,17.566,17.566,0,0,1,17.566,17.565",
    transform: "translate(-725.727 -502.494)",
    fill: "#ffb48a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_49",
    "data-name": "Groupe 49",
    transform: "translate(331.07 232.407)",
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_48",
    "data-name": "Groupe 48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_47",
    "data-name": "Groupe 47",
    clipPath: "url(#hero_background-clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_148",
    "data-name": "Trac\\xE9 148",
    d: "M1091.747,761.571a6.127,6.127,0,0,1-.318-.758c-.029-.087-.056-.174-.082-.261-.008-.033-.036-.132-.039-.148-.161-.628-.3-1.261-.476-1.885a4.916,4.916,0,0,0-1.892-2.859,5.535,5.535,0,0,0-4.5-.4,15.9,15.9,0,0,0-4.013,1.511c-2.547,1.445-4.689,3.9-4.923,6.935a4.81,4.81,0,0,0,1.362,4.042,3.24,3.24,0,0,0,4.1.089,4.74,4.74,0,0,0,1.533-4.767,5.866,5.866,0,0,0-1.232-2.972,9.605,9.605,0,0,1,1.821-.986,13.272,13.272,0,0,1,2.576-.78,3.292,3.292,0,0,1,1.134-.076.543.543,0,0,1,.236.069,1.127,1.127,0,0,1,.184.134c0,.005.006.006.01.012.045.06.092.119.137.178a.219.219,0,0,0,.034.039l.022.052c.074.168.149.334.211.508a6.25,6.25,0,0,1,.263.957,12.092,12.092,0,0,0,.823,2.639,1.678,1.678,0,0,0,2.147.872,1.655,1.655,0,0,0,.872-2.147m-12.451,3.208a.509.509,0,0,1-.124.265.388.388,0,0,0-.046.073c-.05.044-.1.086-.153.126h0c.015-.013.013-.018-.008-.013l0-.008a2.251,2.251,0,0,0-.121-.276,2.587,2.587,0,0,1-.086-.583,4.031,4.031,0,0,1,.339-1.655c.009.043.021.087.031.13a7.457,7.457,0,0,1,.233,1.344,2.087,2.087,0,0,1-.058.6",
    transform: "translate(-1075.489 -754.978)",
    fill: "#f15f5d"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_52",
    "data-name": "Groupe 52",
    transform: "translate(290.083 205.05)",
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_51",
    "data-name": "Groupe 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_50",
    "data-name": "Groupe 50",
    clipPath: "url(#hero_background-clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_149",
    "data-name": "Trac\\xE9 149",
    d: "M975.016,702.105a17.3,17.3,0,0,0,.115,1.966,20.86,20.86,0,1,1,2.941-31.707q-.652,3.072-1.016,6.178a51.3,51.3,0,0,0-.443,7.93,9.435,9.435,0,0,0,1.7,5.391,17.494,17.494,0,0,0-3.293,10.241",
    transform: "translate(-942.343 -666.113)",
    fill: "#f15f5d"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_55",
    "data-name": "Groupe 55",
    transform: "translate(233.626 197.875)",
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_54",
    "data-name": "Groupe 54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_53",
    "data-name": "Groupe 53",
    clipPath: "url(#hero_background-clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_150",
    "data-name": "Trac\\xE9 150",
    d: "M776.375,660.9a20.828,20.828,0,0,1-17.385,20.565c-.033-.672-.049-1.352-.049-2.032a48.18,48.18,0,0,1,.508-6.923,46.476,46.476,0,0,1,6.194-17.213q-.233-2.519-.229-5.088a56.655,56.655,0,0,1,.475-7.406,20.839,20.839,0,0,1,10.487,18.1",
    transform: "translate(-758.94 -642.799)",
    fill: "#f15f5d"
  }))))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_151",
    "data-name": "Trac\\xE9 151",
    d: "M1176.044,342.884s-28.563,134.122-29.184,137.848a30.614,30.614,0,0,1-2.484,7.451L1263.6,512.4s8.693-67.682,15.523-106.8,3.726-50.917,3.726-50.917Z",
    transform: "translate(-792.101 -237.333)",
    fill: "#fc932b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_152",
    "data-name": "Trac\\xE9 152",
    d: "M1261.657,715.693a61.162,61.162,0,1,1-61.162-61.162,61.162,61.162,0,0,1,61.162,61.162",
    transform: "translate(-788.61 -453.045)",
    fill: "#fc932b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_153",
    "data-name": "Trac\\xE9 153",
    d: "M1322.172,231.58a61.162,61.162,0,1,1-61.162-61.162,61.162,61.162,0,0,1,61.162,61.162",
    transform: "translate(-830.496 -117.957)",
    fill: "#fc932b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_154",
    "data-name": "Trac\\xE9 154",
    d: "M937.882,649.219a1.9,1.9,0,0,0-2.293-1.008,1.77,1.77,0,0,0-1.081.916l-1.06.289-2.505.683-5.1,1.393a1.639,1.639,0,1,0,.907,3.149L935,652.389a7.47,7.47,0,0,0,1.982-.656,2.034,2.034,0,0,0,.9-2.514",
    transform: "translate(-640.011 -448.617)",
    fill: "#3b2a3b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_155",
    "data-name": "Trac\\xE9 155",
    d: "M940.973,576.933c.442,3.671-17.377,9.643-20.458,10.708a29.13,29.13,0,0,1-8.7,1.852c-2.491.058-6.358-.221-5.948-3.695.287-2.515,2.712-4.171,4.785-5.227a29.1,29.1,0,0,1,7.5-2.261c5.792-1.171,13.862-4.818,19.843-3.31,1.991.5,2.884,1.164,2.974,1.934",
    transform: "translate(-626.992 -397.747)",
    fill: "#3b2a3b"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_156",
    "data-name": "Trac\\xE9 156",
    d: "M799.316,588.457a4.439,4.439,0,0,1-4.858-.442c-1.344-.926-2.245-2.319-3.466-3.376a9.333,9.333,0,0,0-8.545-1.958,1.506,1.506,0,0,1-.779.344,1.646,1.646,0,0,1-1.86-1.384,5.5,5.5,0,0,1,3.2-5.2c2.024-1.008,4.4-.885,6.587-.86,3.752.033,7.742.573,10.331,3.588,2.236,2.6,2.786,7.333-.606,9.291",
    transform: "translate(-539.756 -398.384)",
    fill: "#3b2a3b"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_157",
    "data-name": "Trac\\xE9 157",
    d: "M900.051,653.622a22.539,22.539,0,1,1,22.539-22.539,22.565,22.565,0,0,1-22.539,22.539m0-40.982a18.443,18.443,0,1,0,18.443,18.443,18.464,18.464,0,0,0-18.443-18.443",
    transform: "translate(-607.386 -421.214)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_158",
    "data-name": "Trac\\xE9 158",
    d: "M811.887,642.041a1.665,1.665,0,0,1-1.851-1.385,12.162,12.162,0,0,0-.942-2.786c-.115-.254-.246-.508-.377-.754-.016-.025-.115-.2-.147-.262s-.1-.155-.107-.172a14.371,14.371,0,0,0-.926-1.3c-.156-.189-.32-.353-.475-.541a.111.111,0,0,0-.025-.033c-.016-.016-.033-.025-.057-.049a.569.569,0,0,1-.107-.09,8.456,8.456,0,0,1,.049,4.023,6.559,6.559,0,0,1-2.212,3.842c-1.475,1.065-3.6.86-4.31-1a6.162,6.162,0,0,1-.254-2.081,18.282,18.282,0,0,1,.033-2.319,7.616,7.616,0,0,1,1.5-4.088,5.571,5.571,0,0,1,3.589-2.122,5.107,5.107,0,0,1,4.219,1.737,15.1,15.1,0,0,1,3.793,7.529,1.667,1.667,0,0,1-1.393,1.852",
    transform: "translate(-553.822 -436.686)",
    fill: "#3b2a3b"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_159",
    "data-name": "Trac\\xE9 159",
    d: "M730.612,635.467a22.539,22.539,0,1,1,22.539-22.539,22.565,22.565,0,0,1-22.539,22.539m0-40.982a18.443,18.443,0,1,0,18.443,18.443,18.464,18.464,0,0,0-18.443-18.443",
    transform: "translate(-490.106 -408.647)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_160",
    "data-name": "Trac\\xE9 160",
    d: "M824.3,734.817a.414.414,0,0,0-.034.069c.012-.021.03-.041.043-.062l-.009-.007",
    transform: "translate(-570.532 -508.617)",
    fill: "#ad7761"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_161",
    "data-name": "Trac\\xE9 161",
    d: "M829.865,625.011a20.871,20.871,0,0,0-3.487-8.924c-1.2-1.739-3.784.28-2.59,2.009a18.672,18.672,0,0,1,2.6,14.313,19.1,19.1,0,0,1-2.847,6.835,16.843,16.843,0,0,1-2.359,2.838c-.96.907-2.081,1.6-3.059,2.48-1.267,1.138-2.487,2.668-2.2,4.484a3.725,3.725,0,0,0,1.357,2.235c.3.255.643.455.964.685.046.032.159.141.251.209a1.978,1.978,0,0,1,.158-.206,1.744,1.744,0,0,0-.149.213.243.243,0,0,0,.094.05c.225.018-.264.283-.138.011-.886,1.536,1.525,3.192,2.816,1.688,1.21-1.41.457-3.365-.833-4.415-.281-.229-1.288-.644-1.3-1.063-.014-.455.68-1.023.985-1.3,1.038-.948,2.24-1.68,3.252-2.665a20.929,20.929,0,0,0,2.781-3.281,23.359,23.359,0,0,0,3.7-16.2",
    transform: "translate(-564.727 -425.974)",
    fill: "#ad7761"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_162",
    "data-name": "Trac\\xE9 162",
    d: "M844.381,743.314a1.658,1.658,0,0,0-2.3-.29,28.064,28.064,0,0,1-12.145,6.148,1.681,1.681,0,0,0-1.388,1.856,1.653,1.653,0,0,0,1.856,1.388,31.5,31.5,0,0,0,13.687-6.8,1.676,1.676,0,0,0,.291-2.3",
    transform: "translate(-573.483 -514.06)",
    fill: "#ad7761"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_163",
    "data-name": "Trac\\xE9 163",
    d: "M1157.412,465.092a1.728,1.728,0,0,0-1.744-.984,7.727,7.727,0,0,0-3.425,1.008,9.366,9.366,0,0,0-.777-2.207,1.639,1.639,0,0,0-3.138.453q-.33,2.426-.658,4.852a1.655,1.655,0,0,0,1.443,1.813,1.8,1.8,0,0,0,.292-.006,1.63,1.63,0,0,0,1.966.574,22.344,22.344,0,0,0,5.536-3.571,1.682,1.682,0,0,0,.505-1.933",
    transform: "translate(-794.373 -319.713)",
    fill: "#3d3033"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_164",
    "data-name": "Trac\\xE9 164",
    d: "M314.2,1195.135c-5.743,18.106-10.315,30.052-10.315,30.052s-29.183,44.708-80.725,18.008c-34.582-17.918-32.9-56.507-32.9-56.507s6.2-14.9,9.307-21.728c.77-1.688,5.35-7.988,11.814-16.558q19.159,11.024,39,20.8,13.518,6.648,27.315,12.691a265.031,265.031,0,0,0,28.036,10.963c2.794.86,5.62,1.63,8.471,2.277",
    transform: "translate(-131.68 -794.887)",
    fill: "#fc932b"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_165",
    "data-name": "Trac\\xE9 165",
    d: "M429.73,877.913a450.082,450.082,0,0,1-9.348,45.987c-1.794-.426-3.6-.86-5.391-1.286-8.758-2.089-17.557-4.064-26.25-6.423a145.245,145.245,0,0,1-24.8-8.971c-7.865-3.785-15.353-8.266-22.866-12.682L328.1,886.9c17.582-22.875,35.508-46.184,35.189-47.486l63.962-28.569s8.693,23.6,2.482,67.068",
    transform: "translate(-227.098 -561.241)",
    fill: "#fcc5a9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_166",
    "data-name": "Trac\\xE9 166",
    d: "M344.922,644.969c1.049,6.669-.606,14.944-6.718,18.794-5,3.154-12.642,2.589-15.985-2.712a1.54,1.54,0,0,1-.049-1.647c-.606-.819-1.2-1.638-1.811-2.449-5.284-7.177-10.913-14.206-15.665-21.752a36.636,36.636,0,0,1-5.08-11.077,17.059,17.059,0,0,1,1.213-11.486,92.146,92.146,0,0,1,6.5-10.626q3.589-5.371,7.546-10.47c4.6-5.916,9.864-12.962,17.573-14.739a14.52,14.52,0,0,1,9.913.934,11.939,11.939,0,0,1,6.046,8.176c1.68,7.628-2.777,14.428-7.832,19.687-2.8,2.909-5.849,5.579-8.439,8.693-.647.779-1.278,1.582-1.844,2.417a1.675,1.675,0,0,0-.213,2.065,35.337,35.337,0,0,0,3.146,4.9c2.319,3.2,4.916,6.2,7.062,9.52a30.368,30.368,0,0,1,4.637,11.773",
    transform: "translate(-207.053 -398.931)",
    fill: "#fcc5a9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_167",
    "data-name": "Trac\\xE9 167",
    d: "M560.529,697.111c-3.755,8.33-13.734,13.24-21.949,11.1-10.354-2.7-18.338-16.422-19.042-27.411-.685-10.693,5.318-21.552,2.269-31.832-.566-1.91-1.347-3.745-1.935-5.656a23.259,23.259,0,0,1-.539-11.962c.733-3.273,2.3-6.614,4.948-8.539a7.978,7.978,0,0,1,8.922-.374c2.979,1.745,5.176,4.644,7.035,7.64a58.162,58.162,0,0,1,5.363,10.906c1.382,3.82,2.405,7.783,3.635,11.663,2.391,7.573,6.206,14.4,9.15,21.707,2.765,6.876,5.39,15.557,2.142,22.764",
    transform: "translate(-359.092 -430.007)",
    fill: "#fcc5a9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_168",
    "data-name": "Trac\\xE9 168",
    d: "M461.023,861.118a14.934,14.934,0,0,1-8.336,5,28.83,28.83,0,0,1-5.555.467,34.675,34.675,0,0,1-5.546-.242c-7.323-1.1-11.914-7.5-16.8-12.853a369.941,369.941,0,0,0-33.7-32.455,1.9,1.9,0,0,1,.6-3.186,2.9,2.9,0,0,1,.075-.529c.415-1.67.847-3.321,1.345-4.964a27.545,27.545,0,0,1,4.4-9.074,20.7,20.7,0,0,1,8.693-6.086c6.866-2.809,14.405-4.263,21.72-3.052,13.475,2.244,24.26,12.629,30.72,25.177a69.354,69.354,0,0,1,7.049,21.38c1.021,7.118.066,14.971-4.658,20.419",
    transform: "translate(-270.252 -549.382)",
    fill: "#fcc5a9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_169",
    "data-name": "Trac\\xE9 169",
    d: "M437.759,740.356c-.816,3.8-4.778,8.093-7.313,10.648-10.708,10.794-26.408,12.922-40.378,7.8a50.849,50.849,0,0,1-18.338-11.744,47.623,47.623,0,0,1-6.8-8.527c-2.593-4.172-1.872-5.864.157-10.25q2.488-5.379,5.219-10.628,5.522-10.615,11.967-20.72,1.569-2.449,3.189-4.864A17.6,17.6,0,0,1,388.684,688c3.292-2.653,7.535-.691,10.93.648,5.077,1.993,9.95,2.88,14.148,6.467,9.419,8.049,15.645,19.449,20,30.885,1.521,3.993,4.676,9.4,4.1,13.8-.024.185-.057.372-.1.561",
    transform: "translate(-251.437 -475.299)",
    fill: "#fcc5a9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_170",
    "data-name": "Trac\\xE9 170",
    d: "M789.028,299.462c-.737,1.13-1.516,2.22-2.351,3.277A48.193,48.193,0,0,1,759.7,319.46a45.363,45.363,0,0,1-15.976.795,62.606,62.606,0,0,1-16.46-4.924c-10.454-4.506-20.523-10.872-31.936-12.666a45.66,45.66,0,0,0-9.274-.377,43.541,43.541,0,0,1-10.38-.221c-5.178-.992-10.544-4.85-11.175-10.463-.713-6.3,5.727-10.044,10.438-12.683a50.022,50.022,0,0,1,17.762-5.866,1.682,1.682,0,0,1,.541.016c1.5-6.792,7.521-12.035,14.1-13.92,7.947-2.269,16.361-.754,24.153,1.45a98,98,0,0,1,20.753,8.742c13.428,7.456,25.292,17.344,36.459,27.823a1.7,1.7,0,0,1,.328,2.294",
    transform: "translate(-459.905 -178.598)",
    fill: "#d3a38d"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_171",
    "data-name": "Trac\\xE9 171",
    d: "M816.39,193.8c-.5,8.532-4.488,16.335-9.311,23.214a121.734,121.734,0,0,1-7.6,9.8c-2.638,3.041-5.7,5.645-9.654,6.724-4.086,1.105-8.386.548-12.438-.428-4.428-1.071-8.78-2.476-13.157-3.761-4.223-1.25-8.523-2.364-12.669-3.855a27.434,27.434,0,0,1-10.279-6.1c-5.311-5.293-7.324-12.892-8.8-20.01-.84-4.043-1.739-8.155,1.148-11.615,1.448-1.73,3.161-3.264,4.754-4.849l5.1-5.1q8.3-8.288,16.584-16.584a1.548,1.548,0,0,1,.437-2.1,16.528,16.528,0,0,1,5.054-2.587c8.3-2.553,16.515.66,23.9,4.369,6.553,3.3,13.346,6.681,18.657,11.83a27.657,27.657,0,0,1,6.279,8.8,26.877,26.877,0,0,1,2,12.249",
    transform: "translate(-506.433 -107.727)",
    fill: "#fcc5a9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_172",
    "data-name": "Trac\\xE9 172",
    d: "M663.833,137.192a1.734,1.734,0,0,1-2.219.976c-1.43-.737-2.861-1.456-4.291-2.176.925,6.408-3.375,12.635-8.994,15.548-7.478,3.88-16.721,1.645-23.976-1.619-3.966-1.79-7.735-3.975-11.624-5.919-7.048-3.539-10.983-4.491-15.737,3.269-2.921,4.769-6.186,9.452-11.066,12.424a16.326,16.326,0,0,1-10.6,2.629,12.99,12.99,0,0,1-8.609-4.8c-5.534-7.333,1.319-16.156,5.68-22.126,6.5-8.911,13.468-20.715,24.727-23.828,11.3-3.124,20.944,3.316,31,7.417q17.706,7.221,34.739,15.982a1.75,1.75,0,0,1,.977,2.219",
    transform: "translate(-390.829 -76.655)",
    fill: "#fcc5a9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_173",
    "data-name": "Trac\\xE9 173",
    d: "M914.782,204a28.073,28.073,0,0,1-13.5,15.248c-7.3,3.778-15.8,4.489-23.883,3.966a105.2,105.2,0,0,1-12.48-1.662,73.525,73.525,0,0,1-12.669-3.392A44.4,44.4,0,0,1,833.859,205.1c-4.84-5.8-8.66-13.277-9.414-20.867a17.814,17.814,0,0,1,2.527-11.7,13.623,13.623,0,0,1,3.418-3.521,27.947,27.947,0,0,1,6.818-8.035l-1.645-.334c-2.159-.411-1.773-3.812.385-3.4q3.328.63,6.639,1.328a336.172,336.172,0,0,1,51.825,14.956c6.416,2.476,13.072,5.688,17.423,11.213A20.009,20.009,0,0,1,914.782,204",
    transform: "translate(-570.577 -108.813)",
    fill: "#fcc5a9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_174",
    "data-name": "Trac\\xE9 174",
    d: "M1380.863,240.5c-13.658,45.331-47.814,39.121-47.814,39.121s-18.442-5.153-41.677-11.847c.049-2.057.107-4.121.172-6.177q.553-16.456,1.7-32.887c.77-11.02,1.827-22.015,2.573-33.034.459-6.784.786-13.592.836-20.392,11.183-1.114,18.926-1.868,20.261-1.844,5.374.1,81.429,9.078,63.954,67.059",
    transform: "translate(-893.847 -120.051)",
    fill: "#fc932b"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_175",
    "data-name": "Trac\\xE9 175",
    d: "M1017.531,271.567c-29.412-8.709-57.432-17.443-61.373-20.2-8.685-6.071-15.517-54.507-15.517-54.507,9.553.958,43.029-1.868,74.08-4.834q.467,21.568,1.254,43.135.664,18.213,1.557,36.409",
    transform: "translate(-651.081 -132.911)",
    fill: "#fcc5a9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_176",
    "data-name": "Trac\\xE9 176",
    d: "M964.851,700.163c4.967,3.726,24.957-6.969,33.029-22.492s49.054-111.769,55.884-113.631,50.917,17.386,44.708,47.191-58.989,93.141-76.375,104.317-31.047,9.935-40.982,4.968-16.264-20.353-16.264-20.353",
    transform: "translate(-667.84 -390.324)",
    fill: "#fc932b"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_177",
    "data-name": "Trac\\xE9 177",
    d: "M785.672,226.321l10.814-10.244c1.519-1.439-.479-4.04-2.009-2.59L784.4,223.03a96.139,96.139,0,0,0-8.8,8.757c-2.361,2.9-4.027,6.38-3.707,10.2a26.612,26.612,0,0,0,1.76,6.436l2.3,6.568,5.208,14.875c.7,2,3.713.707,3.019-1.276l-4.328-12.364c-1.432-4.09-3.109-8.172-4.274-12.347-.991-3.55-.034-6.623,2.146-9.494,2.279-3,5.222-5.483,7.946-8.065",
    transform: "translate(-534.254 -147.474)",
    fill: "#d3a38d"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_178",
    "data-name": "Trac\\xE9 178",
    d: "M862.012,240.1l-8.81,8.833c-2.815,2.822-5.85,5.536-8.458,8.551-2.556,2.955-2.617,6.586-2.009,10.262a95.7,95.7,0,0,0,7.342,23.882c.878,1.919,3.9.645,3.019-1.276a91.937,91.937,0,0,1-6.714-20.837c-.6-3.1-1.553-6.794.545-9.528a42.015,42.015,0,0,1,3.738-3.9l3.979-3.989,9.378-9.4a1.693,1.693,0,0,0,.291-2.3,1.65,1.65,0,0,0-2.3-.29",
    transform: "translate(-583.094 -165.946)",
    fill: "#d3a38d"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_179",
    "data-name": "Trac\\xE9 179",
    d: "M952.164,327.772c-5.122-.72-6.341-7.163-7.326-11.258-1.21-5.027-2.391-10.4-1.417-15.564a1.6,1.6,0,0,0,.187-2.7,1.507,1.507,0,0,0-.821-.748,1.649,1.649,0,0,0-2.123.929c-.037.138-.07.276-.1.414a32.584,32.584,0,0,0-10.315,9.76,1.749,1.749,0,0,0-.3.457c-.151.235-.3.471-.448.71a1.684,1.684,0,0,0,.331,2.294,1.65,1.65,0,0,0,2.293-.331c.085-.14.174-.277.261-.415a7.467,7.467,0,0,1,2.889.6,7.237,7.237,0,0,1,2.866,2.211,7.351,7.351,0,0,1,.791,7.356,1.639,1.639,0,1,0,3.052,1.194,10.112,10.112,0,0,0,.594-1.822,19.261,19.261,0,0,0,2.514,5.806,9.941,9.941,0,0,0,6.706,4.364c2.089.293,2.462-2.963.37-3.257m-17.613-19.486a29.305,29.305,0,0,1,5.352-5.115,36.726,36.726,0,0,0,.605,8.686,10.569,10.569,0,0,0-5.957-3.571",
    transform: "translate(-643.16 -205.849)",
    fill: "#d3a38d"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_180",
    "data-name": "Trac\\xE9 180",
    d: "M446.165,764.421a31.55,31.55,0,0,0-7.079-15.923,32.078,32.078,0,0,0-5.434-5.166,1.646,1.646,0,0,0,.276-.831c4.433-7.013,6.1-15.766,2.416-23.473a90.431,90.431,0,0,0-6.207-10.485,53.141,53.141,0,0,0-6.934-8.7,27.109,27.109,0,0,0-10.529-6.691,1.588,1.588,0,0,0-1.573.294,122.569,122.569,0,0,0-11.012-6.731,18.543,18.543,0,0,0-7.121-2.5,9.8,9.8,0,0,0-6.628,1.9,19.951,19.951,0,0,0-4.333,4.7c-1.5,2.1-2.922,4.257-4.349,6.406q-4.451,6.7-8.64,13.569-4.814,7.893-9.275,15.993a1.649,1.649,0,0,0,.929,2.123,1.682,1.682,0,0,0,2.123-.929q7.293-13.2,15.545-25.844,2.09-3.2,4.238-6.37a52.145,52.145,0,0,1,3.862-5.306,8.274,8.274,0,0,1,4.435-2.888c2.269-.435,4.531.463,6.538,1.441a94.251,94.251,0,0,1,13.117,8.033l-4.236.191a19.648,19.648,0,0,0-5.031.5,6.955,6.955,0,0,0-3.5,3.025c-4.287,6.259-8.525,12.552-12.787,18.827l-7.307,10.759c-1.181,1.739,1.437,3.711,2.625,1.962l12.33-18.155,6.051-8.91a20.154,20.154,0,0,1,2.835-3.956c1.065-.927,2.954-.709,4.264-.768l12.117-.545a1.218,1.218,0,0,0,.395-.088,40.637,40.637,0,0,1,8.216,9.115c.912,1.317,1.788,2.663,2.641,4.025a12.69,12.69,0,0,0-5.583.717,39.8,39.8,0,0,0-4.919,1.754,14.481,14.481,0,0,0-4.308,2.894,34.757,34.757,0,0,0-3.4,4.27l-14.6,20.141c-1.237,1.706,1.384,3.674,2.625,1.963l13.644-18.82c1.93-2.662,3.67-5.6,6.7-7.133a30.872,30.872,0,0,1,4.507-1.723,10.636,10.636,0,0,1,5.249-.76,1.366,1.366,0,0,0,1.6-.825q.73,1.227,1.436,2.465a19.87,19.87,0,0,1,3.054,10.865,24.221,24.221,0,0,1-3.93,11.864c-.009.014-.015.027-.024.041l-.019,0a3.423,3.423,0,0,1-1.563-.886,4.968,4.968,0,0,1-.492-.632,4.866,4.866,0,0,1-.252-.542,1.652,1.652,0,0,0-2.147-.872,1.676,1.676,0,0,0-.872,2.148,6.325,6.325,0,0,0,3.128,3.418,1.359,1.359,0,0,0,.7,1.205,28.993,28.993,0,0,1,10.319,11.163c2.294,4.442,3.687,9.645,2.859,14.65a10.535,10.535,0,0,1-3.593,6.631c-1.643,1.323.365,3.914,2.009,2.59,4.49-3.616,5.6-9.718,4.9-15.18",
    transform: "translate(-248.904 -473.565)",
    fill: "#d3a38d"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_181",
    "data-name": "Trac\\xE9 181",
    d: "M372.485,1094.911c-1.45,5.7-2.95,11.24-4.449,16.541-.295,1.065-.6,2.122-.9,3.162-1.852,6.415-3.687,12.429-5.415,17.885-2.851-.647-5.678-1.417-8.472-2.277a265,265,0,0,1-28.036-10.963q-13.789-6.046-27.315-12.691-19.835-9.758-39-20.8c2.818-3.736,5.989-7.906,9.365-12.314.664-.861,1.327-1.729,2-2.605,3.212-4.195,6.571-8.553,9.938-12.937l12.978,7.636c7.513,4.416,15,8.9,22.866,12.682a145.247,145.247,0,0,0,24.8,8.971c8.693,2.359,17.492,4.334,26.25,6.423,1.794.426,3.6.86,5.391,1.286",
    transform: "translate(-179.201 -732.253)",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_182",
    "data-name": "Trac\\xE9 182",
    d: "M971.234,630.273c-.606,0-.98-.029-1.076-.037a2.049,2.049,0,0,1-1.867-2.214,2.077,2.077,0,0,1,2.21-1.868c.7.053,16.518,1.03,28.008-17.793,12.045-19.737,21.814-40.371,28.248-59.674,2.969-8.906,14.992-68.326,14.24-72.742a30.843,30.843,0,0,0-3.446-7.438,2.048,2.048,0,0,1,3.41-2.271,34.719,34.719,0,0,1,3.991,8.646c1.587,5.558-12.332,69.172-14.308,75.1-6.531,19.591-16.434,40.516-28.639,60.511-11.255,18.442-26.573,19.779-30.77,19.779",
    transform: "translate(-670.215 -322.081)",
    fill: "#d86c12"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_183",
    "data-name": "Trac\\xE9 183",
    d: "M1186.846,582.3a1.763,1.763,0,0,1-.323-.031,1.64,1.64,0,0,1-1.285-1.929c.018-.094,1.9-9.538,5.582-29.775,3.446-18.948,24.859-80.279,28.7-91.2l-33.3-11.077a1.638,1.638,0,0,1,1.034-3.109l34.88,11.6a1.636,1.636,0,0,1,1.028,2.1c-.253.719-25.456,72.139-29.116,92.267-3.685,20.271-5.574,29.738-5.594,29.832a1.637,1.637,0,0,1-1.6,1.317",
    transform: "translate(-820.287 -308.082)",
    fill: "#d86c12"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_184",
    "data-name": "Trac\\xE9 184",
    d: "M584.752,1122.4a2.048,2.048,0,0,1-1.758-1l-3.726-6.208a2.046,2.046,0,0,1-.179-1.724c.111-.323,11.2-32.434,16.093-51.987a245.55,245.55,0,0,0,6.155-37.519,2.048,2.048,0,1,1,4.086.281,249.769,249.769,0,0,1-6.267,38.231c-4.469,17.87-14.037,46.037-15.884,51.427l3.234,5.39a2.05,2.05,0,0,1-1.754,3.1",
    transform: "translate(-400.749 -707.435)",
    fill: "#d86c12"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_185",
    "data-name": "Trac\\xE9 185",
    d: "M784.936,1026.527a92.459,92.459,0,0,1-43.207-11.474c-14.615-8.119-20.945-17.653-21.207-18.055a2.049,2.049,0,0,1,3.429-2.242c.059.091,6.1,9.124,19.769,16.716a88.037,88.037,0,0,0,42.974,10.923,2.048,2.048,0,1,1,.234,4.09c-.147.008-.84.043-1.991.043",
    transform: "translate(-498.492 -687.899)",
    fill: "#d86c12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_58",
    "data-name": "Groupe 58",
    transform: "translate(265.489 382.649)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_57",
    "data-name": "Groupe 57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_56",
    "data-name": "Groupe 56",
    clipPath: "url(#hero_background-clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_186",
    "data-name": "Trac\\xE9 186",
    d: "M885.043,1272.974c-.8.377-1.614.729-2.433,1.065l.18.516s-7.366,2.507-18.877,6.382c-.09-.795-.172-1.606-.254-2.425-1.573-15.6-1.6-34.394-.172-35.467,0,0,1.311,1.63,3.318,4.186,3.048,3.875,7.7,9.865,11.79,15.427a.028.028,0,0,0,.008.017c2.646,3.6,5.047,7.021,6.62,9.577.107.164.213.336.3.492-.164.082-.32.156-.483.229",
    transform: "translate(-862.448 -1243.045)",
    fill: "#fbafe0"
  }))))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_187",
    "data-name": "Trac\\xE9 187",
    d: "M393.624,582.364c-.09,4.186-3.334,7.9-6.923,9.684-3.383,1.679-9.094,2.163-11.47-1.466a6.189,6.189,0,0,1-.016-6.4,8.845,8.845,0,0,1,1.6-2.04,12.074,12.074,0,0,1,7.775-5.866,8.782,8.782,0,0,1,5.94.565,5.816,5.816,0,0,1,3.1,5.522",
    transform: "translate(-259.1 -398.696)",
    fill: "#ffdac4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_188",
    "data-name": "Trac\\xE9 188",
    d: "M579.228,205.627a24.544,24.544,0,0,1-1.181,2.995,12.684,12.684,0,0,1-1.306,2.493c-1.438,1.864-3.214,1.48-5.107,1.013l-5.121-1.251a2.888,2.888,0,0,1-3.668-2.118,8.4,8.4,0,0,1,.976-6.339,14.525,14.525,0,0,1,3.346-4.016,16.584,16.584,0,0,1,4.263-2.867,5.858,5.858,0,0,1,5.151-.068,6.36,6.36,0,0,1,2.942,4.152,11.214,11.214,0,0,1-.293,6.007",
    transform: "translate(-389.388 -134.903)",
    fill: "#ffdac4"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "hero-spark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_189",
    "data-name": "Trac\\xE9 189",
    d: "M367.789,316.58l-14.128-8.11a1.69,1.69,0,0,0-2.293.331,1.649,1.649,0,0,0,.331,2.294l14.128,8.11a1.69,1.69,0,0,0,2.294-.331,1.648,1.648,0,0,0-.331-2.293",
    transform: "translate(-242.988 -213.307)",
    fill: "#ffebd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_190",
    "data-name": "Trac\\xE9 190",
    d: "M398.945,223.159a140.627,140.627,0,0,1-12.961-37.45c-.4-2.067-3.645-1.608-3.244.468a143.675,143.675,0,0,0,13.186,38.258c.959,1.869,3.982.6,3.019-1.276",
    transform: "translate(-264.897 -127.615)",
    fill: "#ffebd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_191",
    "data-name": "Trac\\xE9 191",
    d: "M471.421,244.3a1.672,1.672,0,0,0-1.813,1.444,61.192,61.192,0,0,0-.774,16.267,1.638,1.638,0,1,0,3.243-.468,58.02,58.02,0,0,1,.787-15.429,1.655,1.655,0,0,0-1.443-1.814",
    transform: "translate(-324.357 -169.089)",
    fill: "#ffebd0"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "hero-floating-mark"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.001)",
    clipPath: "url(#hero_background-clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_192",
    "data-name": "Trac\\xE9 192",
    d: "M509.283,384.772l-22.966,22.966a12.326,12.326,0,0,1-17.38,0l-20.785-20.785a12.326,12.326,0,0,1,0-17.38l22.966-22.966a12.325,12.325,0,0,1,17.38,0l20.785,20.785a12.326,12.326,0,0,1,0,17.38",
    transform: "translate(-307.716 -237.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 5.834,
    height: 18.737,
    transform: "translate(201.843 128.883)",
    fill: "#00aeb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_193",
    "data-name": "Trac\\xE9 193",
    d: "M644.7,403.177a17.929,17.929,0,0,0-2.349-4.771,17.433,17.433,0,0,0-9.412-6.913,16.76,16.76,0,0,0-7.057-.571l12.988,14.1a6.179,6.179,0,0,1-.2,8.459L625.9,427.334a16.6,16.6,0,0,0,11.262-2.5,17.4,17.4,0,0,0,6.649-7.5,18.692,18.692,0,0,0,.891-14.152",
    transform: "translate(-433.217 -270.485)",
    fill: "#00aeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_62",
    "data-name": "Groupe 62",
    transform: "translate(128.297 100.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_61",
    "data-name": "Groupe 61",
    clipPath: "url(#hero_background-clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 101.853,
    height: 101.853,
    transform: "translate(-40.481 39.191) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_64",
    "data-name": "Groupe 64",
    transform: "translate(181.316 127.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_63",
    "data-name": "Groupe 63",
    clipPath: "url(#hero_background-clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 33.074,
    height: 33.074,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, -11.291, 11.251)",
    fill: "url(#linear-gradient-2)"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_66",
    "data-name": "Groupe 66",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_65",
    "data-name": "Groupe 65",
    clipPath: "url(#hero_background-clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_196",
    "data-name": "Trac\\xE9 196",
    d: "M1150.893,1040.934c-.7.485-1.371,1-2.011,1.54l-.036-.053c-.521.429-1.047.85-1.545,1.319a24.658,24.658,0,0,0-5.808,8.346,25.993,25.993,0,0,0-1.948,11.636c.168,3.494.3,6.989.438,10.484.213,5.523.4,11.047.629,16.569a17.331,17.331,0,0,1-.652,6.141,16.057,16.057,0,0,1-17.719,10.628,16.4,16.4,0,0,1-4.923-30.864,14.718,14.718,0,0,1,8.183-1.557,23.728,23.728,0,0,1,7.065,2.26c.789.335,1.582.661,2.46,1.027-.145-3.751-.28-7.368-.439-10.983a.7.7,0,0,0-.361-.479,18.879,18.879,0,0,0-1.829-.749,25.02,25.02,0,0,0-9.271-1.4,24.4,24.4,0,0,0-9.467,2.281,26.113,26.113,0,0,0-13.856,14.628,26.705,26.705,0,0,0,11.455,32.716,26.45,26.45,0,0,0,11.6,3.535,25.981,25.981,0,0,0,9.75-1.123,26.507,26.507,0,0,0,10.081-5.832,25.045,25.045,0,0,0,7.565-12.79,28.827,28.827,0,0,0,.565-8.768c-.094-1.419-.1-2.844-.154-4.394,1.45.614,2.764,1.221,4.116,1.73l.318.122a26.71,26.71,0,0,0,3.881,1.452c.6.2,1.213.383,1.83.53a23.634,23.634,0,0,0,13.985-.84c.887-.33,1.734-.705,2.555-1.107a26.605,26.605,0,1,0-26.456-46.005m31.25,21.958a16.3,16.3,0,0,1-7.006,13.562,18.733,18.733,0,0,1-1.975,1.165,14.516,14.516,0,0,1-12.671.425c-3.271-1.35-6.518-2.759-9.784-4.123a.717.717,0,0,1-.521-.766c-.111-3.514-.263-7.026-.393-10.54a14.232,14.232,0,0,1,4.9-11.73l.008-.008c5.448-4.78,11.626-5.572,18.212-2.673a13.852,13.852,0,0,1,2.541,1.47,19.024,19.024,0,0,1,2.647,2.613,19.349,19.349,0,0,1,1.457,2,19.6,19.6,0,0,1,1.687,3.31,15.4,15.4,0,0,1,.9,5.3",
    transform: "translate(-759.954 -717.297)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_197",
    "data-name": "Trac\\xE9 197",
    d: "M1220.455,179.433c-.049,6.8-.377,13.608-.836,20.392-.746,11.019-1.8,22.014-2.573,33.034q-1.143,16.418-1.7,32.887c-.065,2.056-.123,4.121-.172,6.177-3.982-1.147-8.1-2.335-12.3-3.556-1.073-.312-2.147-.631-3.228-.942-5.145-1.5-10.372-3.032-15.55-4.572q-.885-18.2-1.556-36.409-.787-21.567-1.254-43.135c6.382-.606,12.666-1.221,18.614-1.811,1.1-.115,2.18-.221,3.244-.328,6.3-.63,12.167-1.221,17.3-1.736",
    transform: "translate(-817.654 -124.197)",
    fill: "#fff"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "hero-bubble hero-bubble-1",
    id: "Groupe_143",
    "data-name": "Groupe 143",
    transform: "translate(-30.337 590.821) rotate(-47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_141",
    "data-name": "Groupe 141",
    transform: "translate(0 0)",
    clipPath: "url(#hero_background-clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_233",
    "data-name": "Trac\\xE9 233",
    d: "M74.16,35.244C75.537,53.8,56.347,72.558,38.576,75.917,20.364,79.361,1.939,69.271.129,42.564-1.129,24,6.71,4.383,27.471.449c17.77-3.368,45.043,12.638,46.689,34.8",
    transform: "translate(0 0)",
    fill: "#defdff"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "hero-bubble hero-bubble-2",
    id: "Groupe_163",
    "data-name": "Groupe 163",
    transform: "translate(-36.217 505.079) rotate(-47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_141-2",
    "data-name": "Groupe 141",
    transform: "translate(0 0)",
    clipPath: "url(#hero_background-clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_233-2",
    "data-name": "Trac\\xE9 233",
    d: "M23.331,10.041c.433,5.286-5.6,10.63-11.195,11.587-5.73.981-11.526-1.893-12.1-9.5-.4-5.289,2.07-10.877,8.6-12,5.591-.959,14.17,3.6,14.688,9.913",
    transform: "translate(0 -0.001)",
    fill: "#defdff"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "hero-bubble hero-bubble-3",
    id: "Groupe_164",
    "data-name": "Groupe 164",
    transform: "translate(616.783 227.079) rotate(-47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_141-3",
    "data-name": "Groupe 141",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_233-3",
    "data-name": "Trac\\xE9 233",
    d: "M23.331,10.041c.433,5.286-5.6,10.63-11.195,11.587-5.73.981-11.526-1.893-12.1-9.5-.4-5.289,2.07-10.877,8.6-12,5.591-.959,14.17,3.6,14.688,9.913",
    transform: "translate(0 -0.001)",
    fill: "#defdff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBackground);
export default __webpack_public_path__ + "static/media/hero_background.d899ffb2e305cd8b1d986be3ae23ce45.svg";
export { ForwardRef as ReactComponent };